export function repeatStringNumTimes(string: string, times: number): string[] {
  const newArray = Array.from({ length: times }, () => string);
  return newArray;
}
